
export const TEST_STRIPE_PUBLIC_KEY = 'pk_test_51Ji4wMC2R9aJdAuoBn5Q1TasCjN2CFBlGLYK2aN50y1iJD7JRVEgG5AEhH6PvdQf32IYOCFfhvYavMMlBVq5atgn007JKQegmA';
export const PROD_STRIPE_PUBLIC_KEY = 'pk_live_51Ji4wMC2R9aJdAuohJnvBIFYpDBbBQb7xffufLaAsHDEqk2TnefG0OFKCNS2u9B9B5qAVhJ8Ts7plz0Au6VPbZoT009qjDwxbr';
